module.exports = __webpack_public_path__ + "img/time_1.d088d26a.png";